import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import LoginPage from "./pages/Login/LoginPage";
import ForgotPasswordPage from "./pages/ForgotPassword/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPassword/ResetPasswordPage";
import AcceptInvitationPage from "./pages/AcceptInvitation/AcceptInvitationPage";
import DashboardPage from "./pages/Dashboard/DashboardPage";
import ProductsPage from "./pages/Products/ProductsPage";
import ProductDetailPage from "./pages/Products/ProductDetailPage";
import ProductCategoriesPage from "./pages/Products/ProductCategoriesPage";
import ProductCategoryForm from "./pages/Products/ProductCategoryForm";
import EnquiriesPage from "./pages/Enquiries/EnquiriesPage";
import EnquiryDetailPage from "./pages/Enquiries/EnquiryDetailPage";
import UsersPage from "./pages/Users/UsersPage";
import SettingsPage from "./pages/Settings/SettingsPage";
import AuditTrailPage from "./pages/AuditTrail/AuditTrailPage";
import ArticleList from "./pages/Articles/ArticleList";
import ArticleEditor from "./pages/Articles/ArticleEditor";
import ArticlePreview from "./pages/Articles/ArticlePreview";
import ArticleMedia from "./pages/Articles/ArticleMedia";
import ArticleCategoryList from "./pages/Articles/ArticleCategoryList";
import ArticleCategoryForm from "./pages/Articles/ArticleCategoryForm";
import ProtectedRoute from "./components/ProtectedRoute";
import AppLayout from "./components/AppLayout/AppLayout";
import { getToken } from "./api/client";

const RootRedirect = () =>
  getToken() ? <Navigate to="/admin" replace /> : <Navigate to="/login" replace />;

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/accept-invitation" element={<AcceptInvitationPage />} />

        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="products" element={<ProductsPage />} />
          <Route path="products/create" element={<ProductDetailPage />} />
          <Route path="products/categories" element={<ProductCategoriesPage />} />
          <Route path="products/categories/create" element={<ProductCategoryForm />} />
          <Route path="products/categories/:id/edit" element={<ProductCategoryForm />} />
          <Route path="products/:productId" element={<ProductDetailPage />} />
          <Route path="enquiries" element={<EnquiriesPage />} />
          <Route path="enquiries/:enquiryId" element={<EnquiryDetailPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="audit-trail" element={<AuditTrailPage />} />
          <Route path="articles" element={<ArticleList />} />
          <Route path="articles/create" element={<ArticleEditor />} />
          <Route path="articles/:id/edit" element={<ArticleEditor />} />
          <Route path="articles/:id/preview" element={<ArticlePreview />} />
          <Route path="articles/media" element={<ArticleMedia />} />
          <Route path="articles/categories" element={<ArticleCategoryList />} />
          <Route path="articles/categories/create" element={<ArticleCategoryForm />} />
          <Route path="articles/categories/:id/edit" element={<ArticleCategoryForm />} />
          <Route path="articles/tags" element={<Navigate to="/admin/articles/categories" replace />} />
          <Route path="articles/tags/*" element={<Navigate to="/admin/articles/categories" replace />} />
        </Route>

        <Route path="*" element={<RootRedirect />} />
      </Routes>
    </Router>
  );
}

export default App;
